import BadgeDetails from "components/badge-details/badge-details";
export default BadgeDetails;
